define('controllers/termsofuse',['require','layout'],function (require) {
    'use strict';
    var layout = require('layout');
    return {
        load: function () {
            return layout.initStatic('/fe/templates/about/termsofuse');
        },
        unload: $.noop
    };
});

